export default "__VITE_PUBLIC_ASSET__1b8463ab__"